import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { faSquare } from '@fortawesome/free-solid-svg-icons';
import { IntegracaoService } from 'src/app/services/integracao.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})

export class HomeComponent implements OnInit {

  urlData: any;
  code: any;
  state: any;
  dadosIntegracao: any;

  constructor(
    private router: Router
  ) {

  }

  ngOnInit() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    
    let urlParametros = window.location.href.toString().split('/?code=')[1];
    if(urlParametros){
      this.router.navigate(["/integracao"]);
    }
  }

  navegarLogin() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    const prod = 'https%3A%2F%2Fdfe%2Esefaz%2Eto%2Egov%2Ebr';
    const nonce = (Math.random() + 1).toString(36).substring(7);
    const state = (Math.random() + 1).toString(36).substring(7);
    const urlIntegracao = `https://sso.acesso.gov.br/authorize?response_type=code&client_id=dfe.sefaz.to.gov.br&scope=openid+email+phone+profile+govbr_empresa+govbr_confiabilidades&redirect_uri=${prod}&nonce=${nonce}&state=${state}`;
    window.location.href = urlIntegracao;
  }

  abrirLink() {
    window.open('https://falabr.cgu.gov.br/publico/TO/Manifestacao/RegistrarManifestacao', '_blank')
  }

}
